<template>
  <div>
    <Button
      :size="15"
      color="#fd7e14"
      colorText="#ffffff"
      tooltip="Filtrar contenido"
      icon="fas fa-filter"
      round
      :width="30"
      class="mt-2 mb-3 mr-2"
      @click.native="openModal('modal')"
      traslate
    />

    <ui-modal ref="modal" title="Filtros para tabla">
      <!-- Fila 1 -->
      <div class="d-flex">
        <!-- Nombre -->
        <ui-select
          class="w-100 mr-3"
          has-search
          label="Nombre"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :options="dataModulosNombres"
          v-model="nombreModel"
        ></ui-select>

        <!-- Dirección -->
        <ui-select
          class="w-100"
          has-search
          label="Ícono"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :options="dataModulosIconos"
          v-model="iconoModel"
        ></ui-select>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-end mt-3 justify-content-between">
        <button class="btn btn-outline-primary" @click="closeModal('modal')">
          Cerrar
        </button>
        <button
          class="btn btn-outline-secondary"
          @click="clear"
          style="margin-left: 235px"
        >
          Limpiar
        </button>
        <button class="btn btn-outline-danger" @click="filtrarLista">
          Filtrar
        </button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// Select UI
import UiModal from "keen-ui/src/UiModal";
import UiSelect from "keen-ui/src/UiSelect";

// Buttom
import Button from "../../common/Button";

export default {
  props: {
    data: [Object],
  },
  data() {
    return {
      nombreModel: [],
      iconoModel: [],
    };
  },
  computed: {
    ...mapState("superadministrador", [
      "dataDatatableModulosFiltrada",
      "dataModulosNombres",
      "dataModulosIconos",
    ]),
  },
  components: {
    UiSelect,
    UiModal,
    Button,
  },
  // Función computada para acceder a variable de store
  methods: {
    ...mapActions("superadministrador", [
      "actionFilterDataModulos",
      "actionLimpiarFilterDataModulos",
    ]),
    clear() {
      this.nombreModel = [];
      this.iconoModel = [];
      this.actionLimpiarFilterDataModulos();
    },

    filtrarLista() {
      let me = this;

      this.actionLimpiarFilterDataModulos();

      if (this.dataDatatableModulosFiltrada.length > 0) {
        let dataFiltrada = this.dataDatatableModulosFiltrada.filter((item) => {
          if (item.data[0] == me.nombreModel || item.data[1] == me.iconoModel) {
            return item;
          }
        });

        me.actionFilterDataModulos(dataFiltrada);
        this.closeModal("modal");
      }
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
};
</script>
